import s from './styles.scss';
import cx from 'classnames';

export const Label = (props: React.LabelHTMLAttributes<HTMLLabelElement>) => {
  return (
    <label
      className={cx(s.label, props.className)}
      htmlFor={props.htmlFor}
      {...props}
    >
      {props.children}
    </label>
  );
};
